import DateFnsUtils from '@date-io/date-fns'
// import {
//   jssPreset,
//   StylesProvider,
// } from '@mui/material/styles'

import { LocalizationProvider } from '@mui/x-date-pickers'
// import 'antd/dist/antd.css'
// import { create } from 'jss'
import React from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { Provider, useSelector } from 'react-redux'
import { ThemeProvider } from '@emotion/react';
import Routes from './routes/Routes'
import createTheme from './theme'
import { StyledEngineProvider } from '@mui/material'
import store from "./modules/xposProvider/store"
// const jss = create({
//   ...jssPreset(),
//   insertionPoint: document.getElementById('jss-insertion-point'),
// })

function App() {
  const theme = useSelector((state) => state.themeReducer)
  String.prototype.capitalizeFirstLetter = function () {
    return (this && this.charAt(0).toUpperCase() + this.slice(1)) || "";
  }

  return (
    <HelmetProvider>
      <Helmet
        titleTemplate="%s | XPOS"
        defaultTitle="XPOS"
      />

      {/* <StylesProvider jss={jss}> */}
      <LocalizationProvider dateAdapter={DateFnsUtils}>
        {/* <Routes /> */}
        <Provider store={store}>
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={createTheme(theme.currentTheme)}>
              <Routes />
            </ThemeProvider>
          </StyledEngineProvider>
        </Provider>
      </LocalizationProvider>
      {/* </StylesProvider> */}
    </HelmetProvider >
  );
}

export default App
